var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"tr-detail"},[_c('td'),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"detail-content"},[_c('ul',[_c('details-item',{attrs:{"node":_vm.node}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }